module.exports = __webpack_public_path__ + "img/full3-min.26c89a2a.png";